// extracted by mini-css-extract-plugin
export default {"container":"styles_container__GM-wM","header":"styles_header__KIHy8","action":"styles_action__qzDMG"};